import { render, staticRenderFns } from "./RouterView.vue?vue&type=template&id=618d47f7&"
import script from "./RouterView.vue?vue&type=script&lang=ts&"
export * from "./RouterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports